/**
 * @ngdoc service
 * @name  common.service:cmsModalService
 * @description
 *
 * Servicio para añadir funcionalidad de apertura de Popups en páginas de CMS
 */

(function () {
    'use strict';

    angular.module('itxApp.common').factory('mdFeelModalService', mdFeelModalService);

    mdFeelModalService.$inject = ['ItxLoginSvc', 'ngDialog'];

    function mdFeelModalService(ItxLoginSvc, ngDialog) {
        var _this = this;

        var service = {
            openLandingPopup: _openLandingPopup,
            openLoginPopup: _openLoginPopup
        };

        return service;

        /**
         * Función para abrir popups de Feel
         */
        function _openLandingPopup(type) {
            switch (type) {
                // Modal de beneficio: Acceso anticipado
                case 'anticipedAccessToFeel':
                    _this.title = 'crm.anticipedAccess';
                    _this.description = 'crm.anticipedAccess.description_extended';

                    openDialog();

                    break;

                // Modal de beneficio: Paperless
                case 'paperlessModalFeel':
                    _this.title = 'crm.benefits.paperless.title';
                    _this.description = 'crm.benefits.Paperless.longDescription';

                    openDialog();

                    break;

                // Modal de beneficio: Style Advisor
                case 'styleAdvisorModalFeel':
                    _this.title = 'crm.styleAdvisorModalFeel';
                    _this.description = 'crm.styleAdvisorModalFeel.description_extended';

                    openDialog();

                    break;

                // Modal de beneficio: Reservas de Style Advisor
                case 'styleAdvisorBookingsModalFeel':
                    _this.title = 'crm.styleAdvisorBookingsModalFeel';
                    _this.description = 'crm.styleAdvisorBookingsModalFeel.description_extended';

                    openDialog();

                    break;

                // Style appointment
                case 'OTOModalFeel':
                    _this.title = 'dev.myAccount.feel.benefits.OTO.title';
                    _this.description = 'dev.myAccount.feel.benefits.OTO.longDescription';

                    openDialog();

                    break;

                // Modal de beneficio: Plazos de devoluciones
                case 'returnsModalFeel':
                    _this.title = 'crm.returnsModalFeel';
                    _this.description = 'crm.returnsModalFeel.description_extended';

                    openDialog();

                    break;

                // Modal de beneficio: Contacto por Whatsapp
                case 'whatsappModalFeel':
                    _this.title = 'feel.landing.benefits.whatsapp.title';
                    _this.description = 'feel.landing.benefits.whatsapp.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Colecciones especiales
                case 'specialCollectionsModalFeel':
                    _this.title = 'feel.landing.benefits.collections.title';
                    _this.description = 'feel.landing.benefits.collections.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Acceso anticipado a colecciones especiales
                case 'accesoColeccionesModalFeel':
                    _this.title = 'crm.benefits.AccesoColecciones.title';
                    _this.description = 'crm.benefits.AccesoColecciones.longDescription';

                    openDialog();

                    break;

                // Modal de beneficio: Promociones
                case 'promotionsModalFeel':
                    _this.title = 'feel.landing.benefits.promotions.title';
                    _this.description = 'feel.landing.benefits.promotions.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Acceso anticipado a promociones
                case 'accesoPromocionesModalFeel':
                    _this.title = 'crm.benefits.AccesoPromociones.title';
                    _this.description = 'crm.benefits.AccesoPromociones.longDescription';

                    openDialog();

                    break;

                // Modal de beneficio: Experiencias exclusivas
                case 'exclusiveExperiencesModalFeel':
                    _this.title = 'feel.landing.benefits.experiences.title';
                    _this.description = 'feel.landing.benefits.experiences.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Proximamente
                case 'commingSoonModalFeel':
                    _this.title = 'feel.landing.benefits.more_benefits.title';
                    _this.description = 'feel.landing.benefits.more_benefits.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Fidelidad
                case 'fidelityModalFeel':
                    _this.title = 'feel.landing.benefits.fidelity.title';
                    _this.description = 'feel.landing.benefits.fidelity.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Arreglos
                case 'arrangementsModalFeel':
                    _this.title = 'feel.landing.benefits.arrangements.title';
                    _this.description = 'feel.landing.benefits.arrangements.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Devoluciones
                case 'devolutionsModalFeel':
                    _this.title = 'feel.landing.benefits.devolutions.title';
                    _this.description = 'feel.landing.benefits.devolutions.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Regalos
                case 'giftingModalFeel':
                    _this.title = 'feel.landing.benefits.gifting.title';
                    _this.description = 'feel.landing.benefits.gifting.text_modal';

                    openDialog();

                    break;

                // Modal de beneficios: Gifting
                case 'giftingByPointsModalFeel':
                    _this.title = 'dev.myAccount.feel.benefits.giftingByPoints.title';
                    _this.description = 'dev.myAccount.feel.benefits.giftingByPoints.longDescription';

                    openDialog();

                    break;

                // Modal de beneficios: Profile completition
                case 'profileCompletionModalFeel':
                    _this.title = 'dev.myAccount.feel.benefits.profileCompletion.title';
                    _this.description = 'dev.myAccount.feel.benefits.profileCompletion.longDescription';

                    openDialog();

                    break;

                // Modal de beneficios: Puntos dobles
                case 'doublePointsModalFeel':
                    _this.title = 'dev.myAccount.feel.benefits.doublePoints.title';
                    _this.description = 'dev.myAccount.feel.benefits.doublePoints.longDescription';

                    openDialog();

                    break;

                // Modal de beneficios: Free alteration Service
                case 'freeAlterationServiceModalFeel':
                    _this.title = 'dev.myAccount.feel.benefits.FreeAlterationService.title';
                    _this.description = 'dev.myAccount.feel.benefits.FreeAlterationService.longDescription';

                    openDialog();

                    break;

                // Modal de beneficios: Cupones
                case 'couponsModalFeel':
                    _this.title = 'dev.myAccount.feel.benefits.coupons.title';
                    _this.description = 'dev.myAccount.feel.benefits.coupons.longDescription';

                    openDialog();

                    break;

                // Modal de beneficio: Extra
                case 'extraModalFeel':
                    _this.title = 'crm.extra.title';
                    _this.description = 'feel.landing.benefits.extra.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Extra 1
                case 'extraBenefit1ModalFeel':
                    _this.title = 'feel.landing.benefits.extra1.title';
                    _this.description = 'feel.landing.benefits.extra1.text_modal';

                    openDialog();

                    break;

                // Modal de beneficio: Extra 2
                case 'extraBenefit2ModalFeel':
                    _this.title = 'feel.landing.benefits.extra2.title';
                    _this.description = 'feel.landing.benefits.extra2.text_modal';

                    openDialog();

                    break;

                // Modal de beneficios: Birthday Gift
                case 'birthdayGift':
                    _this.title = 'dev.myAccount.feel.benefits.birthdaygift.title';
                    _this.description = 'dev.myAccount.feel.benefits.birthdaygift.longDescription';

                    openDialog();

                    break;
            }
        }

        /**
         * Función para el popup de login
         */
        function _openLoginPopup() {
            ItxLoginSvc.popupSignIn();
        }

        /**
         * Función para abrir popups de Feel
         */
        function openDialog() {
            ngDialog.open({
                template: '<crm-modals title="ngDialogData.title" description="ngDialogData.description"></crm-modals>',
                className: 'new-modal ma-modal-sm ngdialog-theme-plain',
                plain: true,
                showClose: true,
                data: {
                    title: _this.title,
                    description: _this.description
                }
            });
        }
    }
})();
